"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _store = require("../@api/store");
var _firebase = _interopRequireDefault(require("../@api/appcenter/firebase.config"));
var _useInterval = _interopRequireDefault(require("./useInterval"));
var _useAsyncEffect = _interopRequireDefault(require("./useAsyncEffect"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterFirestore = _firebase["default"].firestore();
var domainCollection = appcenterFirestore.collection('whitelabelDomains');
var companyCollection = appcenterFirestore.collection('company');
var licenseCollection = appcenterFirestore.collection('license');
function useWhitelabel() {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    storeState = _useState2[0],
    setStoreState = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    whitelabel = _useState4[0],
    setWhitelabel = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    whitelabelLicense = _useState6[0],
    setWhitelabelLicense = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var domain = window.location.hostname;
  var _ref = storeState || {},
    auth = _ref.appcenter;
  (0, _useInterval["default"])(function () {
    var state = _store.store.getState();
    if (JSON.stringify(state) !== JSON.stringify(storeState)) {
      setStoreState(state);
    }
  }, '1s');
  (0, _useAsyncEffect["default"])( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _auth$company, _company$meta, _yield$domainCollecti, docs, domainDoc, whitelabelDomain, companyUid, companyDoc, company, fixedApp, query, _yield$query$get, licenseDocs, licenses, _whitelabelLicense, paidOrFreeLicense;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (auth !== null && auth !== void 0 && auth.isAuthContextCreated) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.prev = 2;
          setLoading(true);
          _context.next = 6;
          return domainCollection.where('domain', '==', domain).where('selected', '==', true).where('deleted', '==', false).get();
        case 6:
          _yield$domainCollecti = _context.sent;
          docs = _yield$domainCollecti.docs;
          domainDoc = docs[0];
          whitelabelDomain = (domainDoc === null || domainDoc === void 0 ? void 0 : domainDoc.data()) || undefined;
          companyUid = (auth === null || auth === void 0 ? void 0 : (_auth$company = auth.company) === null || _auth$company === void 0 ? void 0 : _auth$company.uid) || (whitelabelDomain === null || whitelabelDomain === void 0 ? void 0 : whitelabelDomain.company);
          if (companyUid) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return");
        case 13:
          _context.next = 15;
          return companyCollection.doc(companyUid).get();
        case 15:
          companyDoc = _context.sent;
          company = companyDoc.data();
          if (company) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return");
        case 19:
          fixedApp = (whitelabelDomain === null || whitelabelDomain === void 0 ? void 0 : whitelabelDomain.app) === 'workflux-portal' ? 'workflux' : whitelabelDomain === null || whitelabelDomain === void 0 ? void 0 : whitelabelDomain.app;
          query = licenseCollection.where('company', '==', companyUid).where('type', '==', 'whitelabel-enterprise').where('deleted', '==', false);
          if (!!whitelabelDomain && fixedApp !== 'appcenter-customer') {
            query = query.where('app', '==', fixedApp);
          }
          _context.next = 24;
          return query.get();
        case 24:
          _yield$query$get = _context.sent;
          licenseDocs = _yield$query$get.docs;
          licenses = licenseDocs.map(function (doc) {
            return doc.data();
          });
          _whitelabelLicense = licenses[0] || undefined;
          if (!!whitelabelDomain && fixedApp === 'appcenter-customer') {
            paidOrFreeLicense = licenses.find(function (license) {
              return ['paid', 'free'].includes(license.status);
            });
            if (paidOrFreeLicense) _whitelabelLicense = paidOrFreeLicense;
          }
          setWhitelabelLicense(_whitelabelLicense);
          setWhitelabel(_objectSpread({}, ((_company$meta = company.meta) === null || _company$meta === void 0 ? void 0 : _company$meta.whitelabel) || {}));
          _context.next = 37;
          break;
        case 33:
          _context.prev = 33;
          _context.t0 = _context["catch"](2);
          console.log('>=> >=>  WHITELABEL ERROR  <=< <=<');
          console.log('error: >=>', _context.t0);
        case 37:
          _context.prev = 37;
          setLoading(false);
          return _context.finish(37);
        case 40:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 33, 37, 40]]);
  })), [storeState, auth, domain]);
  return {
    loading: loading,
    whitelabel: whitelabel,
    whitelabelLicense: whitelabelLicense
  };
}
var _default = useWhitelabel;
exports["default"] = _default;